import { stateName } from './constants';

const localState = state => state[stateName];

export const getUserStats = state => localState(state).stats;
export const getRequestState = state => localState(state).requestState;